import React from "react";
import { DragAndDrop, DragAndDropItem, ensure, NamedProperty } from "sprint-common-web";

import { useCreateOrder } from "../common/provider/useCreateOrder";
import { OrderSoundtrackItem } from "../types/OrderSoundtrackItem";

interface OrderSoundtracksSequencerProps {
    label: string;
}

export const OrderSoundtracksSequencer: React.FC<OrderSoundtracksSequencerProps> = ({ label }) => {
    const { muxSpecification, soundtracks, setSoundtracks } = useCreateOrder();

    const reindexSoundtracks = (reorderedElements: DragAndDropItem[]) => {
        const newSoundtracks = reorderedElements.map<OrderSoundtrackItem>((element, index) => {
            const soundtrack = soundtracks.find((item) => item.id === element.key);
            ensure(soundtrack);

            return { ...soundtrack, index: index + 1 };
        });

        setSoundtracks(newSoundtracks);
    };

    if (!muxSpecification?.isSequentialForSoundtracks || soundtracks.length < 2) {
        return <></>;
    }

    return (
        <DragAndDrop
            label={label}
            items={soundtracks.map((soundtrack) => mapToDragAndDropItem(soundtrack))}
            onDrop={reindexSoundtracks}
        />
    );
};

const mapToDragAndDropItem = (item: NamedProperty): DragAndDropItem => {
    return { key: item.id, text: item.name };
};
